import styles from './RoleChip.module.scss';
import cx from 'classnames';
import { Text } from 'components';
import { UserRole } from 'types';

type Props = {
  role: UserRole;
};

export const RoleChip = ({ role }: Props) => {
  const roleText = role === UserRole.CLINIC ? 'Studio' : role;
  return (
    <div className={cx(styles.chip, styles[role.toLowerCase()])}>
      <Text type="overline">{roleText}</Text>
    </div>
  );
};
